import { render, staticRenderFns } from "./artefacts.vue?vue&type=template&id=c020e5e0&scoped=true&"
import script from "./artefacts.vue?vue&type=script&lang=js&"
export * from "./artefacts.vue?vue&type=script&lang=js&"
import style0 from "./artefacts.vue?vue&type=style&index=0&id=c020e5e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c020e5e0",
  null
  
)

export default component.exports